import { nameof } from "../../app/utils/nameof";
import { assertNumber, assertTrue } from "../../app/utils/assert";

export const assertId = (param: object) => {
    const name = nameof(param);
    const value = param[name] as number;

    assertNumber(value, `parameter ${name} has to be a number`);
    assertTrue(value > 0, `${name} has to be a valid id`);
}


// WEBPACK FOOTER //
// ./src/rest/Geotab/common.ts